/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PixV2 {
  id?: string;
  reference?: string;
  tid?: string;
  creationDateTime?: string;
  amount?: number;
  qrcodeResponseDateTimeExpiration?: string;
  qrcodeResponseImage?: string;
  qrcodeResponseData?: string;
  returnCode?: string;
  returnMessage?: string;
  transactionId?: number;
  status?: string;
  statusChangedDateTime?: string | null;
  refunded?: boolean;
  refundDateTime?: string | null;
  refundAmount?: number | null;
  refundId?: string | null;
  refundStatus?: string | null;
  establishmentId?: number;
  purchaseAmount?: number;
  purchaseCurrency?: string;
  posId?: string | null;
  paymentLinkId?: string | null;
  cpf?: string | null;
  amountBrl?: number | null;
  exchangeRate?: number;
  iof?: number;
  spread?: number;
  pixProcessmentFee?: number;
  pixProcessmentCostBrl?: number | null;
  estimatedRemittanceCostBrl?: number | null;
  estimatedMarginBrl?: number | null;
  estimatedMarginPercentage?: number | null;
  customerName?: string | null;
  customerEmail?: string | null;
  customerPhoneNumber?: string | null;
  customerAddress?: string | null;
  customerCity?: string | null;
  customerZipCode?: string | null;
  customerCountryId?: number;
  establishmentName?: string | null;
  countryName?: string | null;
}
